import { Component } from '@angular/core';

@Component({
  selector: 'mad-content-panel-container-content',
  templateUrl: './content-panel-container-content.component.html',
  styleUrls: ['./content-panel-container-content.component.scss'],
  standalone: true,
})
export class ContentPanelContainerContentComponent {}
